import breakpoint from "../Breakpoint";

function isMobileView() {
    return breakpoint() === 'xs' || breakpoint() === 'sm' || breakpoint() === 'md' || breakpoint() === 'lg';
}

document.addEventListener('DOMContentLoaded', () => {
    const Selectors = {
        SHOWCASE_VIDEO_IFRAME: '#jsVideoCollectionIframe',
        SHOWCASE_VIDEO_TITLE: '.jsVideoCollectionTitle',
        SHOWCASE_VIDEO_SUBTITLE: '.jsVideoCollectionSubTitle',
        SHOWCASE_VIDEO_TEXT: '.jsVideoCollectionText',
        SHOWCASE_VIDEO_ITEM: '.jsVideoCollectionItem',
        SHOWCASE_VIDEO_SUMMARY: '.jsVideoItemModalSummary',
        DOCTORS_SECTION: '.video-showcase-collection-block-content .meet-your-doctors .doctors',
    };

    const DataAttributes = {
        SHOWCASE_DATA_VIDEO_LINK: 'data-video-link',
        SHOWCASE_DATA_TITLE: 'data-title',
        SHOWCASE_DATA_SUBTITLE: 'data-subtitle',
        SHOWCASE_DATA_TEXT: 'data-text-html',
    };

    const showcasevideoIframe = document.querySelector(Selectors.SHOWCASE_VIDEO_IFRAME);
    const showcasevideoTitleDiv = document.querySelector(Selectors.SHOWCASE_VIDEO_TITLE);
    const showcasevideoSubtitleDiv = document.querySelector(Selectors.SHOWCASE_VIDEO_SUBTITLE);
    const showcasevideoTextDiv = document.querySelector(Selectors.SHOWCASE_VIDEO_TEXT);
    const showcasevideoItems = Array.from(document.querySelectorAll(Selectors.SHOWCASE_VIDEO_ITEM));
    const showcasedoctorsSection = document.querySelector(Selectors.DOCTORS_SECTION);
    const doctorsShowcaseTitle = document.querySelector('.video-showcase-collection-block-content .meet-your-doctors-title');
    const showcaseModalSummaryDiv = document.querySelector(Selectors.SHOWCASE_VIDEO_SUMMARY);

    let currentlyPlayingItem;
    if (showcasedoctorsSection) {
        currentlyPlayingItem = showcasedoctorsSection.querySelector('.selected-video');
        if (!currentlyPlayingItem) {
            currentlyPlayingItem = document.createElement('div');
            currentlyPlayingItem.classList.add('doctors-item', 'selected-video');
            currentlyPlayingItem.textContent = 'Currently Playing: ';
            showcasedoctorsSection.insertBefore(currentlyPlayingItem, showcasedoctorsSection.firstChild);
        }
    }

    function playFirstVideo(section) {
        let defaultTitle = showcasevideoTitleDiv ? showcasevideoTitleDiv.textContent.trim() : 'Unknown Title';

        if (showcasevideoItems && showcasevideoItems.length > 0) {
            if (section === showcasedoctorsSection && currentlyPlayingItem) {
                currentlyPlayingItem.textContent = `Currently Playing: ${defaultTitle}`;
            }
        }
    }
    playFirstVideo(showcasedoctorsSection);

    if (showcasevideoItems && showcasevideoItems.length > 0) {
        showcasevideoItems.forEach(item => {
            item.addEventListener('click', onVideoItemClick);
        });
    }

    function onVideoItemClick(event) {
        event.preventDefault();

        const videoLink = this.getAttribute(DataAttributes.SHOWCASE_DATA_VIDEO_LINK);
        const newTitle = this.getAttribute(DataAttributes.SHOWCASE_DATA_TITLE);
        const newSubTitle = this.getAttribute(DataAttributes.SHOWCASE_DATA_SUBTITLE);
        const newSummary = this.getAttribute(DataAttributes.SHOWCASE_DATA_TEXT);

        if (showcasevideoIframe) showcasevideoIframe.src = videoLink;
        if (showcasevideoTitleDiv) showcasevideoTitleDiv.innerHTML = newTitle;
        if (showcasevideoSubtitleDiv) showcasevideoSubtitleDiv.innerHTML = newSubTitle;
        if (showcasevideoTextDiv) showcasevideoTextDiv.innerHTML = newSummary;
        if (showcaseModalSummaryDiv) showcaseModalSummaryDiv.innerHTML = newSummary;

        if (currentlyPlayingItem) currentlyPlayingItem.textContent = `Currently Playing: ${newTitle}`;
    }

    if (showcasedoctorsSection && doctorsShowcaseTitle) {
        if (!isMobileView()) {
            showcasedoctorsSection.style.display = 'block';
        } else {
            showcasedoctorsSection.style.display = 'none';
            doctorsShowcaseTitle.addEventListener('click', () => {
                const isExpanded = showcasedoctorsSection.style.display === 'block';
                showcasedoctorsSection.style.display = isExpanded ? 'none' : 'block';
                doctorsShowcaseTitle.classList.toggle('active', !isExpanded);
            });
        }
    }
});